import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import { drills } from 'redux/modules'
import PropTypes from 'prop-types'
import Loader from './Loader'


const DrillsLoader = ({
  children,
  params,
  fetchDrills,
  activeLanguage: { code: locale },
  ...restProps
}) => (
  <Loader
    fetchMethod={() => fetchDrills({ ...params, locale })}
    triggers={[locale]}
    {...restProps}
  >
    {children}
  </Loader>
)

DrillsLoader.defaultProps = {
  params: {},
}

DrillsLoader.propTypes = {
  children: PropTypes.node.isRequired,
  params: PropTypes.shape(),
  fetchDrills: PropTypes.func.isRequired,
  activeLanguage: PropTypes.shape().isRequired,
}

export default compose(
  connect(
    null,
    { fetchDrills: drills.fetchDrills }
  ),
  withLocalize
)(DrillsLoader)
